import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPage: 1,
  currentFilter: "all",
  currentPageSize: 20,
  currentRecheckPage: 1,
  currentRecheckPageSize: 20,
  sortBy: "",
  sortOrder: "",
  search: "",
  selectedBilling: "",
  billingData: [],
  item_type: [],
  shop: [],
  status: [],
  date: [],
  from_date: "",
  to_date: "",
  editModal: false,
  printData: "",
  printChellanData: "",
  stockPrintData: "",
  BillEstimate: {
    currentPage: 1,
    currentFilter: "all",
    currentPageSize: 10,
    sortBy: "",
    sortOrder: "desc",
    search: "",
    clear: false,
    activeTab: "orders",
    warningModal: false,
  },
  clear: false,
};
const completedDeliverySlice = createSlice({
  name: "completedDelivery",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
    resetConfig: () => initialState,
  },
});

export const { updateConfig, resetConfig } = completedDeliverySlice.actions;

export default completedDeliverySlice.reducer;
